<app-shared-beneficiary-selection [datasource]="datasource"
                                  [showMatricules]="showMatricules"
                                  [title]="title">

    <a class="gup-O-link -secondary"
       (click)="openSelectionBeneficiaryDialog()">
        Faire un ajout multiple
    </a>

</app-shared-beneficiary-selection>
